import {Component, OnInit} from '@angular/core';
import {SortDescriptor,process} from '@progress/kendo-data-query';
import {ExcelExportEvent, GridComponent, PageChangeEvent} from '@progress/kendo-angular-grid';
import {GLReview} from '../../../core/shared/model/GLReview';
import {GlguideService} from '../../../core/services/glguide.service';
import { FSInvoiceDialogService } from '~/app/core/services/fsinvoice.dialog.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';


@Component({
  selector: 'app-glreviewguide',
  templateUrl: './glreviewguide.component.html',
  styleUrls: ['./glreviewguide.component.scss']
})

export class GLReviewGuideComponent implements OnInit {
  public glGuideReview: Array<GLReview> = this.glGuideService.glReviewList;
  public gridData: any;
  pageSize: number = 60;
  skip = 0;
  selectedKeys: string[];
  sort: SortDescriptor[] = [{
    field: 'siteName',
    dir: 'asc'
  }];
  scale=0.7;

  constructor(public glGuideService: GlguideService,
     public loadingIndicator: LoadingIndicatorHelper,
     public dialogService: FSInvoiceDialogService)
      {
      this.exportAllData = this.exportAllData.bind(this);
      }

  async ngOnInit() {
    this.gridData = this.glGuideReview;
    this.loadingIndicator.hide();
  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

 //Excel export
 public exportAllData(): ExcelExportData {
  const result: ExcelExportData = {
    data: process(this.gridData, {}).data,
  };
  return result;
}

excelExported($event: ExcelExportEvent) {
  const sheet = $event.workbook.sheets[0];
  sheet.freezePane.rowSplit = 0;
  sheet.name = 'GlReviewguide';
}

exportToExcel(glReviewGuide: GridComponent) {
  try {
    this.loadingIndicator.show();
    setTimeout(() => {
      glReviewGuide.saveAsExcel();
      this.loadingIndicator.hide();
    }, 100);
  } catch (ex) {
    this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
    this.loadingIndicator.hide();
  }
}


  //PDF export
  exportToPDF(glReviewGuide: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        glReviewGuide.saveAsPDF();
        this.loadingIndicator.hide();
      }, 200);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }
}
